module.exports = "img/flags/LR.cd565a5.png";